const gtag = (...args) => window.gtag?.(...args);

export const trackEvent = (name, params) => {
  try {
    gtag('event', name, params);
  } catch (e) {
    console.warn(`Analytics: failed to track event "${name}"`, e);
  }
};
